import { Button, Grid } from '@mui/material'
import React, { FC } from 'react'
import styles from './chargeOverrideStyle'
import CreateOverride from './CreateOverride'
import OverridesGrid from './OverridesGrid'

const Overrides: FC = () => {
  const [showCreateFields, setShowCreateFields] = React.useState<boolean>(false)
  const [triggerRefetch, setTriggerRefetch] = React.useState<number>(0)

  const handleCreateComplete = () => {
    setShowCreateFields(false)
    setTriggerRefetch((prev) => prev + 1) // Increment to trigger refetch
  }

  return (
    <Grid container spacing={4} direction="column">
      <Grid container spacing={3}>
        <Grid item xs={12} sx={styles.buttonGrid}>
          <Button
            type="button"
            variant="outlined"
            className={`${styles.round} ${styles['tumblr']}`}
            onClick={() => setShowCreateFields(true)}
          >
            Create custom override
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={11} sx={styles.componentPanel}>
          <OverridesGrid shouldRefetchData={triggerRefetch} />
        </Grid>
      </Grid>
      <CreateOverride
        openState={showCreateFields}
        setOpenState={setShowCreateFields}
        onComplete={handleCreateComplete}
      />
    </Grid>
  )
}

export default Overrides
